/* Ginspire Wellness — cart-drawer.js (AJAX cart, drawer, free-shipping bar) */
(function () {
  const drawer = document.getElementById('CartDrawer');
  if (!drawer) return;
  const money = (cents) => {
    const fmt = drawer.getAttribute('data-money-format') || '${{amount}}';
    const amount = (cents / 100).toFixed(2);
    return fmt.replace('{{amount}}', amount).replace('{{amount_no_decimals}}', Math.round(cents / 100));
  };
  const threshold = parseFloat(drawer.getAttribute('data-free-shipping') || '0') * 100;

  function open() { drawer.setAttribute('open', ''); document.body.style.overflow = 'hidden'; }
  function close() { drawer.removeAttribute('open'); document.body.style.overflow = ''; }
  drawer.querySelectorAll('[data-cart-close]').forEach((b) => b.addEventListener('click', close));
  document.querySelectorAll('[data-cart-open]').forEach((b) => b.addEventListener('click', (e) => { e.preventDefault(); refresh().then(open); }));
  document.addEventListener('keydown', (e) => { if (e.key === 'Escape') close(); });

  function render(cart) {
    const items = drawer.querySelector('[data-cart-items]');
    const empty = drawer.querySelector('[data-cart-empty]');
    const foot = drawer.querySelector('[data-cart-foot]');
    const sub = drawer.querySelector('[data-cart-subtotal]');
    const ship = drawer.querySelector('[data-cart-shipping]');
    const bar = drawer.querySelector('[data-cart-bar]');
    document.querySelectorAll('[data-cart-count]').forEach((c) => (c.textContent = cart.item_count));
    items.innerHTML = '';
    if (!cart.items.length) { empty.hidden = false; foot.hidden = true; ship.hidden = true; return; }
    empty.hidden = true; foot.hidden = false; ship.hidden = false;
    cart.items.forEach((it) => {
      const row = document.createElement('div');
      row.className = 'cart-item';
      const img = it.image ? `<img src="${it.image.replace(/(\.[a-z]+)(\?|$)/, '_160x160$1$2')}" alt="">` : '<span class="gw-ph">IMG</span>';
      const plan = it.selling_plan_allocation ? `<div class="cart-item__meta">${it.selling_plan_allocation.selling_plan.name}</div>` : '';
      const variant = it.variant_title && it.variant_title !== 'Default Title' ? `<div class="cart-item__meta">${it.variant_title}</div>` : '';
      row.innerHTML = `${img}<div class="cart-item__body"><div class="cart-item__title">${it.product_title}</div>${variant}${plan}
        <div class="cart-item__row"><div class="qty"><button type="button" aria-label="Decrease" data-line="${it.key}" data-delta="-1">−</button><input type="number" min="0" value="${it.quantity}" data-line-input="${it.key}"><button type="button" aria-label="Increase" data-line="${it.key}" data-delta="1">+</button></div>
        <strong>${money(it.final_line_price)}</strong></div>
        <button type="button" class="cart-item__remove" data-remove="${it.key}">Remove</button></div>`;
      items.appendChild(row);
    });
    sub.textContent = money(cart.items_subtotal_price);
    if (threshold > 0) {
      const remain = threshold - cart.items_subtotal_price;
      ship.querySelector('[data-cart-shipping-text]').textContent = remain > 0 ? `You're ${money(remain)} away from free shipping` : 'You qualify for free shipping';
      bar.style.width = Math.min(100, Math.round((cart.items_subtotal_price / threshold) * 100)) + '%';
    } else { ship.hidden = true; }
  }

  function refresh() { return fetch('/cart.js').then((r) => r.json()).then((c) => { render(c); return c; }); }
  function change(key, quantity) {
    return fetch('/cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ id: key, quantity }) }).then((r) => r.json()).then(render);
  }

  drawer.addEventListener('click', (e) => {
    const d = e.target.closest('[data-line]');
    if (d) { const input = drawer.querySelector(`[data-line-input="${d.getAttribute('data-line')}"]`); change(d.getAttribute('data-line'), Math.max(0, parseInt(input.value, 10) + parseInt(d.getAttribute('data-delta'), 10))); }
    const rm = e.target.closest('[data-remove]');
    if (rm) change(rm.getAttribute('data-remove'), 0);
  });
  drawer.addEventListener('change', (e) => {
    const input = e.target.closest('[data-line-input]');
    if (input) change(input.getAttribute('data-line-input'), Math.max(0, parseInt(input.value, 10)));
  });

  window.GWCart = { open, close, refresh, add: (body) => fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(body) }).then((r) => r.json()).then(() => refresh()).then(open) };
  refresh();
})();
